/**
 * Eventos internos del carrito público. Fail-silent, sin SDKs nuevos y sin
 * datos personales: sólo el nombre del evento y contadores agregados.
 *
 * Embudo: add_to_cart → cart_open → begin_checkout → whatsapp_order_clicked.
 */

import logger from '@/lib/logger';

export type OrderingEvent =
  | 'add_to_cart'
  | 'cart_open'
  | 'begin_checkout'
  | 'whatsapp_order_clicked';

const seenOnce = new Set<string>();

/**
 * Vistas deduplicadas por carga de página (p. ej. abrir el resumen varias
 * veces no infla la métrica). Las intenciones de envío NO se deduplican.
 */
export function trackOrderingEventOnce(event: OrderingEvent, data: Record<string, number | string> = {}): void {
  if (seenOnce.has(event)) return;
  seenOnce.add(event);
  trackOrderingEvent(event, data);
}

/** Sólo para pruebas: reinicia la deduplicación de vistas. */
export function __resetOrderingEventDedupe(): void {
  seenOnce.clear();
}

export function trackOrderingEvent(event: OrderingEvent, data: Record<string, number | string> = {}): void {
  try {
    logger.track(`ordering:${event}`, data);
    const layer = (window as unknown as { dataLayer?: unknown[] }).dataLayer;
    if (Array.isArray(layer)) {
      layer.push({ event: `plaxter_${event}`, ...data });
    }
  } catch {
    /* la analítica nunca bloquea el pedido */
  }
}
